const STOP_WORDS = new Set(['and', 'the', 'of', 'for']);

function words(value: string): string[] {
  return value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((word) => word && !STOP_WORDS.has(word));
}

function sameWord(left: string, right: string): boolean {
  if (left === right) return true;
  const stem = (word: string) => (word.length > 3 && word.endsWith('s') ? word.slice(0, -1) : word);
  return stem(left) === stem(right);
}

export function packageMatchesShootType(
  pkg: { category?: string; categories?: string[] },
  selectedName: string
): boolean {
  const selected = words(selectedName);
  const tokens = words([pkg.category || '', ...(pkg.categories || [])].join(' '));
  return tokens.some((token) => selected.some((word) => sameWord(token, word)));
}

/**
 * A package can be quoted from when it is marked for quoting,
 * or when that choice has never been set and the package is still available.
 */
export function packageIsQuotable(pkg: { available?: boolean; forQuoting?: boolean }): boolean {
  if (pkg.forQuoting === true) return true;
  if (pkg.forQuoting === false) return false;
  return pkg.available !== false;
}

/** Catalogue names such as Portrait or Wedding, in the order Carmen chooses a quotation. */
export function quoteCategoryNames(packages: { category?: string }[]): string[] {
  const names = new Set<string>();
  packages.forEach((pkg) => {
    const name = String(pkg.category || '').trim();
    if (name) names.add(name);
  });
  return Array.from(names).sort((left, right) => left.localeCompare(right, 'en'));
}

/** Map a free-text enquiry ("family portraits") onto one catalogue quotation name. */
export function matchQuoteCategory(shootType: string, categories: string[]): string {
  const wanted = shootType.trim();
  if (!wanted) return '';
  const exact = categories.find((name) => name.toLowerCase() === wanted.toLowerCase());
  if (exact) return exact;
  return categories.find((name) => (
    packageMatchesShootType({ category: name }, wanted)
    || packageMatchesShootType({ category: wanted }, name)
  )) || '';
}
